import Message from "@/components/Message/Message";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import SplitLayout from "@/components/SplitLayout/SplitLayout";
import useTranslation from "@/hooks/useTranslation";
import { Col, Row, Space } from "antd";
import Details from "../detail/Details/FacilityDetails";
import styles from "../detail/FacilityDetail.module.scss";
import { FacilityDetailsModeEnum } from "../types";

export default function AddFacility() {
  const translations = useTranslation();

  return (
    <>
      <PageHeader
        title={"Add facility"}
        description={translations.facility.detail.pageDescription}
      />
      <div className={styles.facility}>
        <SplitLayout
          left={
            <div className={styles.utilitiesContainerAddFacility}>
              <Space
                direction={"vertical"}
                style={{ width: "100%" }}
                size={8}
              >
                <Row
                  gutter={[0, 8]}
                  className={styles.header}
                >
                  <Col span={24}>
                    <span className={styles.title}>
                      {translations.facility.detail.utilities.title}
                    </span>
                  </Col>
                  <Col span={24}>
                    <span>{translations.facility.detail.utilities.description}</span>
                  </Col>
                </Row>
                <Message type="note">Utilities can be added after saving the facility.</Message>
              </Space>
            </div>
          }
          right={<Details mode={FacilityDetailsModeEnum.add} />}
        />
      </div>
    </>
  );
}
